import { jsonp, ajax } from '@ifeng-fe/ui_base';
import { batchQuerySubjectCount } from '../utils/api';
/* eslint-disable no-undef */
const apiBaseUrl = apiUrl;
// 整理圈子数据的通用函数
// 请求圈子数据

export const getQuanDataList = async (id, tag) => {
    return new Promise((resolve, reject) => {
        const request = new XMLHttpRequest(); // 新建XMLHttpRequest对象

        // eslint-disable-next-line func-names
        request.onreadystatechange = function() {
            // 状态发生变化时，函数被回调
            if (request.readyState === 4) {
                // 成功完成
                // 判断响应结果:
                if (request.status === 200) {
                    // 成功，通过responseText拿到响应的文本:
                    resolve(request.responseText);
                    // return success(request.responseText);
                } else {
                    // 失败，根据响应码判断失败原因:
                    // return fail(request.status);
                }
            } else {
                // HTTP请求还在继续...
            }
        };

        // 发送请求:
        request.open('POST', 'https://api-group.ifeng.com/gateway/search/multiContent');
        request.setRequestHeader('Content-Type', 'application/json');
        const orders = [{ column: 'utime', asc: false }];

        orders.unshift({ column: 'indexUtime', asc: false });
        request.send(
            JSON.stringify({
                pages: {
                    current: 1,
                    hitCount: false,
                    optimizeCountSql: true,
                    records: [],
                    searchCount: true,
                    size: 10,
                    orders,
                },
                where: { orgId: id, boutique: 1 },
            }),
        );
    });
};
//  获取评论的数据
const getCommentData = async ids => {
    const res = await batchQuerySubjectCount(ids);

    if (res?.length > 0) {
        const obj = {};

        res.forEach(item => {
            obj[item.subjectId] = item.num;
        });

        return obj;
    } else {
        return {};
    }
};

export const getQuanData = async (id, tag, func) => {
    // 从ids 获取数据信息
    // 查询ids 的评论
    // 查询ids 的点赞状况
    // 模拟数据
    console.log(id);
    const res = await func(id, tag);
    const { data } = JSON.parse(res);

    let { records } = data;
    const commentArray = [];

    records = records.map((item, index) => {
        item['dataInfo'] = item['content'];
        item['likeInfo'] = item['like'];
        item['commentInfo'] = {};
        item['type'] = 'quan';
        commentArray.push(item['content']['id']);

        return item;
    });

    const commentData = await getCommentData(commentArray);

    records = records.map((item, index) => {
        if (commentData[item['content']['id']]) {
            item['commentInfo']['num'] = commentData[item['content']['id']];
        }

        return item;
    });
    // const commentRes = await getCommentData (ids);

    // console.log (commentRes, 3333);

    return records;
};
